import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import { requiredRule } from '@utils/rules'
import { Form, Input } from 'antd'

const Create = ({ form, formProps }: SBRMFormActionProps) => {
  return (
    <Form {...formProps} form={form} layout="vertical">
      <Form.Item
        name="friendlyName"
        label="Friendly name"
        rules={[requiredRule()]}
      >
        <Input />
      </Form.Item>

      <Form.Item name="slug" label="Slug" rules={[requiredRule()]}>
        <Input />
      </Form.Item>
    </Form>
  )
}

export default Create
